import React, { useContext } from 'react';
import { useIsSignedIn, useIsSigningIn } from 'entity/user/userHooks';
import { useSelectFollowedGroupList } from 'entity/group/groupHooks';

import HomeContent from './HomeContent';
import TrendingContent from './TrendingContent';
import GroupContent from './GroupContent';
import DiscoverGroupContent from './DiscoverGroupContent';
import ArticleContent from './ArticleContent';
import JoinGroupsContent from './OnboardContent/JoinGroupsContent';

import { CommunityPageContext } from '../context/CommunityPageContext';

const MainContents = () => {
  const { pageType } = useContext(CommunityPageContext);

  const isSignedIn = useIsSignedIn();
  const isSigningIn = useIsSigningIn();
  const followedGroups = useSelectFollowedGroupList();

  switch (pageType) {
    case 'home': {
      // if not signed in and not following any groups
      if ((!isSignedIn && !isSigningIn) || followedGroups.length === 0) {
        return <JoinGroupsContent />;
      }

      return <HomeContent />;
    }
    case 'trending': {
      return <TrendingContent />;
    }
    case 'group': {
      return <GroupContent />;
    }
    case 'discover-groups': {
      return <DiscoverGroupContent />;
    }
    case 'article': {
      return <ArticleContent />;
    }
    default:
      return <div />;
  }
};

export default MainContents;
